/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import React from 'react';

import { AtomProps } from './types';

import styles from './power-up.less';

const Details: React.FunctionComponent<AtomProps> = ({
  name,
  subtitle,
  icon,
}) => (
  <div className={styles.flexRow}>
    <div className={styles.relative}>
      <span
        className={styles.icon}
        style={{
          backgroundImage: `url(${icon.url})`,
        }}
      />
    </div>
    <div className={styles.nameContainer}>
      <span className={styles.name}>{name}</span>
      {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
    </div>
  </div>
);

const Atom: React.FunctionComponent<AtomProps> = (props) => (
  <div className={classNames(styles.flexRowSpaceBetween, props.className)}>
    <Details {...props} />
    {props.button}
  </div>
);

export default Atom;
